import { defineMessages } from 'react-intl';
export default defineMessages({
  yourProducts: {
    id: 'wishlist.your.products',
    defaultMessage: 'Oblíbené produkty',
  },
  sharedProducts: {
    id: 'wishlist.shared.products',
    defaultMessage: 'Sdílené produkty',
  },
  noProducts: {
    id: 'wishlist.your.products.empty',
    defaultMessage: 'Zatím nemáte <b>oblíbené produkty</b> ',
  },
  emptyGuide: {
    id: 'wishlist.empty.guide',
    defaultMessage:
      'Jednoduše klikněte na symbol srdíčka u vaší oblíbené položky.',
  },
  productsCount: {
    id: 'wishlist.productsCount',
    defaultMessage: 'Produktů',
  },
  refreshButton: {
    id: 'wishlist.refreshButton.text',
    defaultMessage: 'Obnovit',
  },
  backToWishlistList: {
    id: 'wishlist.backToWishlistList',
    defaultMessage: 'Zpět na přehled seznamů',
  },
  missingProductsInfoTooltip: {
    id: 'wishlist.missingProductsInfoTooltip',
    defaultMessage:
      'Produkty, které už nejsou v prodeji, momentálně ve seznamu oblíbených nezobrazujeme. Proto tam některé položky můžou chybět. Na vylepšení už pracujeme!',
  },
});
